import Vue from "vue";
import VTooltip from "v-tooltip";

export default Vue.use(VTooltip);
